
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 25.08 35.92"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Vrstva_2","data-name":"Vrstva 2"}},[_c('path',{attrs:{"d":"M12.56 35.92l-.39-.45C11.67 34.88 0 21 0 12.54a12.54 12.54 0 0125.08 0c0 8-11.64 22.32-12.14 22.92zM12.54 1A11.56 11.56 0 001 12.54c0 7.23 9.5 19.29 11.55 21.81 2-2.57 11.53-14.93 11.53-21.81A11.55 11.55 0 0012.54 1zm0 17.07a5.63 5.63 0 114-1.65 5.63 5.63 0 01-4 1.65zm0-10.27a4.64 4.64 0 103.28 7.91 4.64 4.64 0 00-3.28-7.91z","id":"Vrstva_1-2","data-name":"Vrstva 1"}})])])
          )
        }
      }
    